export default class ModalButtonsConfig {
  constructor(primaryButton, secondaryButton, primaryButtonHandler = null, secondaryButtonHandler = null) {
    if (primaryButton) {
      this.primaryButtonText = primaryButton.text || "";
      this.primaryButtonIcon = primaryButton.icon || "";
      this.primaryButtonDisabled = primaryButton.disabled || false;
      this.primaryButtonHandler = primaryButtonHandler;
    }
    if (secondaryButton) {
      this.secondaryButtonText = secondaryButton.text || "";
      this.secondaryButtonIcon = secondaryButton.icon || "";
      this.secondaryButtonDisabled = secondaryButton.disabled || false;
      this.secondaryButtonHandler = secondaryButtonHandler;
    }
  }
}
